import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "freightInput", "marginInput", "resultsFrame"]
  static values = {
    resultsUrl: String,
    pdfUrl: String,
    productCostingId: Number
  }

  connect() {
    if (this.hasDialogTarget && !this.dialogTarget.open) {
      this.dialogTarget.showModal()
    }
  }

  disconnect() {
    if (this._debounce) clearTimeout(this._debounce)
  }

  recalculate() {
    if (!this.resultsUrlValue) return

    if (this._debounce) clearTimeout(this._debounce)
    this._debounce = setTimeout(() => {
      const frame = this.hasResultsFrameTarget
        ? this.resultsFrameTarget
        : this.element.querySelector("#resell-calculator-results")
      if (!frame) return

      const url = new URL(this.resultsUrlValue, window.location.origin)
      url.searchParams.set("freight_cost_lb", this.freightInputTarget?.value ?? "")
      url.searchParams.set("margin_percent", this.marginInputTarget?.value ?? "")
      frame.src = url.toString()
    }, 250)
  }

  print() {
    if (!this.pdfUrlValue || !this.productCostingIdValue) return

    const form = document.createElement("form")
    form.method = "POST"
    form.action = this.pdfUrlValue
    form.target = "_blank"
    form.style.display = "none"

    const token = document.querySelector('meta[name="csrf-token"]')?.content
    if (token) {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "authenticity_token"
      input.value = token
      form.appendChild(input)
    }

    const fields = {
      id: this.productCostingIdValue,
      freight_cost_lb: this.freightInputTarget?.value ?? "",
      margin_percent: this.marginInputTarget?.value ?? "",
      format: "pdf"
    }

    Object.entries(fields).forEach(([name, value]) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = name
      input.value = value
      form.appendChild(input)
    })

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  close() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }
}
